import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import { backgroundGrey4 } from 'lib/css/colors';
import ManufacturerRow from 'components/manage_manufacturers/manufacturer_details/ManufacturerRow';

const manufacturerRows = {
  name: 'Manufacturer Name',
  manufacturer_url: 'Manufacturer Website',
  manufacturer_glns: 'Manufacturer GLNs',
  gln_source: 'GLN Source Preference',
  description: 'Description',
  is_partner: 'Is a manufacturer partner',
  upb_data_provider: 'Is a UPB data provider',
  requires_manufacturer_portal: 'Creation of manufacturer portal is required',
  preserve_product_name_casing: 'Preserve product name casing',
  influence_status: 'Influence status',
  sync_branded_products_only_to_cd: 'Sync only branded products to C+D',
  similar_manufacturers: 'Similar Manufacturers',
};

function ManufacturerDetailView({
  manufacturer,
  updateManufacturer,
  refetch,
  clientGlobalManufacturerData,
  updateClientGlobalManufacturer,
}) {
  return (
    <div className="px-4 mt-3">
      {Object.keys(manufacturerRows).map(key => (
        <div key={key}>
          <ManufacturerRow
            label={key}
            title={manufacturerRows[key]}
            manufacturer={manufacturer}
            updateManufacturer={updateManufacturer}
            refetch={refetch}
            clientGlobalManufacturerData={clientGlobalManufacturerData}
            updateClientGlobalManufacturer={updateClientGlobalManufacturer}
          />
          <hr className={css(styles.separator)} />
        </div>
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  separator: {
    color: backgroundGrey4,
    backgroundColor: backgroundGrey4,
    margin: '6px 0',
  },
});

ManufacturerDetailView.propTypes = {
  manufacturer: PropTypes.object,
  updateManufacturer: PropTypes.func,
  refetch: PropTypes.func,
  clientGlobalManufacturerData: PropTypes.object,
  updateClientGlobalManufacturer: PropTypes.func,
};

export default ManufacturerDetailView;
export { manufacturerRows };
